export default {
  routerObj: {
    path: '/subsystem',
    component: () => import('@/views/routerView.vue'),
    name: '子系统',
    children: [
      {
        path: '/subsystem/subsystemHome',
        component: () => import('@/views/subsystem/subsystemHome/index.vue'),
        name: '子系统主页'
      },
      {
        path: '/subsystem/dataDictionary',
        component: () => import('@/views/subsystem/dataDictionary/index.vue'),
        name: '数据字典',
        props: true
      },
      {
        path: '/subsystem/menuPc',
        component: () => import('@/views/subsystem/menuPc/index.vue'),
        name: 'PC菜单管理',
        props: true
      },
      {
        path: '/subsystem/menuApp',
        component: () => import('@/views/subsystem/menuApp/index.vue'),
        name: 'APP菜单管理',
        props: true
      },
      {
        path: '/subsystem/menuWx',
        component: () => import('@/views/subsystem/menuWx/index.vue'),
        name: '小程序菜单管理',
        props: true
      },
      {
        path: '/subsystem/sysResources',
        component: () => import('@/views/subsystem/sysResources/index.vue'),
        name: '系统资源管理',
        props: true
      },
      {
        path: '/subsystem/sageGuide',
        component: () => import('@/views/subsystem/sageGuide/index.vue'),
        name: '使用指南',
        props: true
      },
      {
        path: '/subsystem/commonProblem',
        component: () => import('@/views/subsystem/commonProblem/index.vue'),
        name: '常见问题',
        props: true
      },
      {
        path: '/subsystem/customcolumns',
        component: () => import('@/views/subsystem/customcolumns/index.vue'),
        name: '自定义列'
      }
    ]
  }
}
